import React, { useState } from "react";
import ComingSoon from "../Common/ComingSoon";
import Header from "../Common/Header";
import Sidebar from "../Common/Sidebar";
import { useNavigate } from "react-router-dom";

export default function Simulator() {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const onSidebarClick = (val: any) => {
    setSidebarOpen(val);
  };
  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar pagename="simulator" onSidebarClick={() => onSidebarClick(false)} sidebarOpen={sidebarOpen} />
      {/* Main Content */}
      <main className="flex-1 h-screen overflow-y-auto p-4 md:p-8 ">
        <Header onSidebarClick={() => onSidebarClick(true)} />

        <div className="flex flex-col min-h-[calc(100vh-185px)] justify-center items-center">
          <ComingSoon />
        </div>
      </main>
    </div>
  );
}
